<template>
    <div class="help-guaranteed">
        <section class="help__section">
            <h2 class="help__section-title">Guaranteed реклама</h2>
            <p class="help__section-desc">
                Гарантированные показы с фиксированным расписанием. Процесс:
                <strong>Креатив → Кампания → Объявление</strong>
            </p>

            <ol class="help__steps">
                <li class="step">
                    <div class="step__num">1</div>
                    <div class="step__body">
                        <h3 class="step__title">Создайте Guaranteed креатив</h3>
                        <div class="step__content">
                            <p>Загрузите картинку или видео и укажите параметры.</p>
                            <ul>
                                <li><b>Тип</b>: картинка или видео</li>
                                <li><b>Название</b>: как креатив будет виден в списке</li>
                                <li><b>Размер</b>: ширина и высота в пикселях</li>
                                <li><b>Длительность</b>: для видео (в мс)</li>
                                <li><b>Аудио</b>: отметьте, если есть звуковая дорожка</li>
                            </ul>
                            <div class="step__actions">
                                <a href="/guaranteed/creatives/create" class="btn btn--primary">Создать Guaranteed
                                    креатив</a>
                                <a href="/guaranteed/creatives" class="btn">Список креативов</a>
                            </div>
                            <div class="note">
                                После создания креатив отправляется на модерацию (обычно до 24 часов).
                            </div>
                        </div>
                    </div>
                </li>

                <li class="step">
                    <div class="step__num">2</div>
                    <div class="step__body">
                        <h3 class="step__title">Настройте кампанию</h3>
                        <div class="step__content">
                            <p>
                                Укажите период и адресную программу (фреймы), задайте частоту показов.
                            </p>
                            <ul>
                                <li><b>Период</b>: локальные дата и время начала/окончания</li>
                                <li><b>Фреймы</b>: выберите площадки на карте</li>
                                <li>
                                    <b>Частота</b>: repetitions за интервал
                                    <code>loopDuration</code> (мс)
                                </li>
                                <li>
                                    <b>Интервалы</b>: списки периодов и <i>time settings</i> по
                                    дням/часам
                                </li>
                                <li><b>Комментарий</b>: по желанию</li>
                            </ul>
                            <div class="step__actions">
                                <a href="/guaranteed/campaigns/create" class="btn btn--primary">Создать кампанию</a>
                                <a href="/guaranteed/campaigns" class="btn">Список кампаний</a>
                            </div>
                            <div class="tip">
                                Для разного расписания добавьте несколько интервалов и настроек по дням.
                            </div>
                        </div>
                    </div>
                </li>

                <li class="step">
                    <div class="step__num">3</div>
                    <div class="step__body">
                        <h3 class="step__title">Создайте объявление в кампании</h3>
                        <div class="step__content">
                            <p>
                                Откройте страницу кампании, перейдите на вкладку «Объявления» и создайте объявление,
                                привязав креативы.
                            </p>
                            <ul>
                                <li><b>Кампания</b>: выбранная ранее (объявление создаётся внутри кампании)</li>
                                <li><b>Тип</b>: картинка или видео</li>
                                <li><b>Период</b>: когда объявление активно</li>
                                <li><b>Креативы</b>: один или несколько (только Guaranteed креативы)</li>
                                <li>
                                    <b>Инвентарь</b>: GID фреймов (можно сузить относительно кампании)
                                </li>
                                <li><b>Время внутри дня</b>: опционально</li>
                            </ul>
                            <div class="step__actions">
                                <a href="/guaranteed/campaigns" class="btn">Открыть кампании</a>
                            </div>
                            <div class="note">
                                Объявления создаются внутри кампании. Откройте нужную кампанию и перейдите на вкладку
                                «Объявления».
                            </div>
                        </div>
                    </div>
                </li>
            </ol>
        </section>

        <section class="help__section">
            <h2 class="help__section-title">Навигация: Guaranteed</h2>
            <div class="help__navigation">
                <div class="nav-item">
                    <h4>Guaranteed</h4>
                    <p>Раздел для работы с гарантированной рекламой</p>
                    <ul>
                        <li><a href="/guaranteed/campaigns">Кампании</a></li>
                        <li><a href="/guaranteed/creatives">Креативы</a></li>
                        <li><a href="/guaranteed/stats">Статистика</a></li>
                    </ul>
                </div>
            </div>
        </section>

        <section class="help__faq help-guaranteed__faq">
            <h2>Частые вопросы (Guaranteed)</h2>
            <details>
                <summary>В чём разница между Guaranteed и RTB?</summary>
                <p>
                    <strong>Guaranteed:</strong> гарантированные показы с фиксированным расписанием. Нужно создать
                    креатив, кампанию и объявление.
                    <br><strong>RTB:</strong> реклама через аукцион в реальном времени. Креатив и кампания RTB
                    настраиваются отдельно.
                </p>
            </details>
            <details>
                <summary>Объявление не показывается (Guaranteed)</summary>
                <p>
                    Убедитесь, что статусы кампании и объявления одобрены/активны и есть доступные
                    слоты по частоте. Проверьте, что объявление создано внутри кампании.
                </p>
            </details>
            <details>
                <summary>Где создать объявление для Guaranteed кампании?</summary>
                <p>
                    Объявления создаются внутри кампании. Откройте нужную кампанию, перейдите на вкладку «Объявления» и
                    нажмите «Создать объявление».
                </p>
            </details>
        </section>
    </div>
</template>

<script>
export default {
    name: 'HelpGuaranteed',
};
</script>
